import { BehaviorSubject } from "rxjs";

export interface AutocompleteInputOptions {
  labelText: string;
  placeholder?: string;
  list: BehaviorSubject<{ [key: string]: any; }[]>;
  optionSelected?: (params?: any) => void,
  optionLabel: string;
  optionValue: string;
}
